import { render, staticRenderFns } from "./AddFieldUserModal.vue?vue&type=template&id=0b72e43c&scoped=true&"
import script from "./AddFieldUserModal.vue?vue&type=script&lang=js&"
export * from "./AddFieldUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b72e43c",
  null
  
)

export default component.exports